import React from 'react';
import { useScreenInit } from './useScreenInit';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Team } from './components/Team';
import { Courses } from './components/Courses';
import { Location } from './components/Location';
import { BookingBanner } from './components/BookingBanner';
import { Footer } from './components/Footer';
export function App() {
  useScreenInit();
  return <div className="min-h-screen w-full bg-background font-sans text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Services data-id="element-3" />
        <Gallery data-id="element-4" />
        <Team data-id="element-5" />
        <Courses data-id="element-6" />
        <Location data-id="element-7" />
        <BookingBanner data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}